export default () => {
    const locationPage = document.querySelector(".content-inner #map");

    if (locationPage) {
        const mapElement = document.getElementById("map");

        if (mapElement) {
            const mapElementParent = mapElement.parentElement;

            mapElementParent.classList.add('mapParent');

            // Contact - Google Map
            const mapCenter = {
                lat: 50.08312693715864,
                lng: 14.439800711900695
            };

            if (mapElement.classList.contains('location-barcelona')){
                mapCenter.lat = 41.4028523;
                mapCenter.lng = 2.1963648;
            }

            const map = new google.maps.Map(mapElement, {
                // zoom: window.outerWidth > 1000 ? 9.5 : 8.5,
                zoom: 12,
                center: mapCenter,
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                // styles
                styles: [{
                        elementType: "geometry",
                        stylers: [{
                            color: "#535459"
                        }]
                    },
                    {
                        elementType: "labels.text.stroke",
                        stylers: [{
                            color: "#3C3D40"
                        }]
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [{
                            color: "#A6A5AA"
                        }]
                    },
                    {
                        featureType: "administrative.locality",
                        elementType: "labels.text.fill",
                        stylers: [{
                            color: "#A6A5AA"
                        }],
                    },
                    {
                        featureType: "poi",
                        elementType: "labels.text.fill",
                        stylers: [{
                            color: "#A6A5AA"
                        }],
                    },
                    {
                        featureType: "poi.park",
                        elementType: "geometry",
                        stylers: [{
                            color: "#3C3D40"
                        }],
                    },
                    {
                        featureType: "poi.park",
                        elementType: "labels.text.fill",
                        stylers: [{
                            color: "#A6A5AA"
                        }],
                    },
                    {
                        featureType: "road",
                        elementType: "geometry",
                        stylers: [{
                            color: "#3C3D40"
                        }],
                    },
                    {
                        featureType: "road",
                        elementType: "geometry.stroke",
                        stylers: [{
                            color: "#3C3D40"
                        }],
                    },
                    {
                        featureType: "road",
                        elementType: "labels.text.fill",
                        stylers: [{
                            color: "#A6A5AA"
                        }],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry",
                        stylers: [{
                            color: "#3C3D40"
                        }],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry.stroke",
                        stylers: [{
                            color: "#3C3D40"
                        }],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "labels.text.fill",
                        stylers: [{
                            color: "#A6A5AA"
                        }],
                    },
                    {
                        featureType: "transit",
                        elementType: "geometry",
                        stylers: [{
                            color: "#3C3D40"
                        }],
                    },
                    {
                        featureType: "transit.station",
                        elementType: "labels.text.fill",
                        stylers: [{
                            color: "#A6A5AA"
                        }],
                    },
                    {
                        featureType: "water",
                        elementType: "geometry",
                        stylers: [{
                            color: "#3C3D40"
                        }],
                    },
                    {
                        featureType: "water",
                        elementType: "labels.text.fill",
                        stylers: [{
                            color: "#A6A5AA"
                        }],
                    },
                    {
                        featureType: "water",
                        elementType: "labels.text.stroke",
                        stylers: [{
                            color: "#A6A5AA"
                        }],
                    },
                    {
                        featureType: "poi",
                        elementType: "labels",
                        stylers: [{
                            visibility: "off"
                        }]
                    },
                    {
                        featureType: "road.highway",
                        elementType: "labels.icon",
                        stylers: [{
                            visibility: "off"
                        }]
                    },
                    {
                        featureType: "road.arterial",
                        elementType: "labels.icon",
                        stylers: [{
                            color: "#3C3D40"
                        }]
                    },

                ],
            });

            const observer = new IntersectionObserver(entries => {

                entries.forEach(entry => {
                    const intersecting = entry.isIntersecting
                    if (intersecting) {
                        setTimeout(drop, 350);
                        observer.unobserve(entry.target);
                    }
                })
            })

            observer.observe(mapElement)

            function drop() {

                const locations = [{
                        lat: 50.0830925149893,
                        lng: 14.439800711900695,
                        name: "THE MINERS CHURCHILL",
                        address: "Italská 2584/69, Praha 3",
                        weekdaysOpening: "7.00-20.00",
                        saturdayOpening: "9.00-19.00",
                        sundayOpening: "9.00-19.00"
                    },
                    {
                        lat: 50.07890686543286,
                        lng: 14.448166727243212,
                        name: "THE MINERS JZP",
                        address: "Slavíkova 1611/5, Praha 5",
                        weekdaysOpening: "7.00-20.00",
                        saturdayOpening: "8.00-20.00",
                        sundayOpening: "8.30-20.00"
                    },
                    {
                        lat: 50.08655417821719,
                        lng: 14.421839556079037,
                        name: "THE MINERS OLD TOWN",
                        address: "Železná 490/14, Praha 1",
                        weekdaysOpening: "8.30-19.30",
                        saturdayOpening: "8.30-19.30",
                        sundayOpening: "8.30-19.30"
                    },
                    {
                        lat: 50.0984025,
                        lng: 14.3657414,
                        name: "THE MINERS BOŘISLAVKA",
                        address: "Evropská 866/71, Praha 6",
                        weekdaysOpening: "7.30-21.00",
                        saturdayOpening: "10.00-21.00",
                        sundayOpening: "10.00-21.00"
                    },
                    {
                        lat: 50.0817641,
                        lng: 14.4163381,
                        name: "WEWORK",
                        address: "Národní 135/14, Praha 1",
                        weekdaysOpening: "Pouze pro členy/ Members only",
                        saturdayOpening: "Pouze pro členy/ Members only",
                        sundayOpening: "Pouze pro členy/ Members only"
                    },
                    {
                        lat: 50.1040196,
                        lng: 14.4667027,
                        name: "THE MINERS ROASTERY",
                        address: "Boudníková 2538/11, Praha 8",
                        weekdaysOpening: "7:30-19:00",
                        saturdayOpening: "9:00-18:00",
                        sundayOpening: "9:00-18:00"
                    },
                    {
                        lat: 50.0963146,
                        lng: 14.4606967,
                        name: "THE MINERS BAKERY",
                        address: "Sokolovská 713, Praha 8",
                        weekdaysOpening: "7:00-20:00",
                        saturdayOpening: "8:00-20:00",
                        sundayOpening: "8:00-20:00"
                    },
                    {
                        lat: 41.4028523,
                        lng: 2.1963648,
                        name: "THE MINERS RAMBALA DEL POBLENOU",
                        address: "Rambla del Poblenou 107",
                        weekdaysOpening: "8.00-19.00",
                        saturdayOpening: "9.00-19.00",
                        sundayOpening: "9.00-19.00"
                    },
                    {
                        lat: 41.3803564,
                        lng: 2.1567435,
                        name: "THE MINERS GRAN VIA",
                        address: "Gran Via de les Corts Catalanes 488/3 ",
                        weekdaysOpening: "8.00-19.00",
                        saturdayOpening: "9.00-19.00",
                        sundayOpening: "9.00-19.00"
                    }
                ]

                function markerContent(title, address, weekdaysOpening, saturdayOpening, sundayOpening) {

                    const lang = shoptet.cookie.get("language");

                    const czWeekdays = "Pondělí až pátek";
                    const czSaturday = "Sobota";
                    const czSunday = "Neděle";
                    const enWeekdays = "Monday to Friday";
                    const enSaturday = "Saturday";
                    const enSunday = "Sunday";

                    return `
                <div class = "marker__content">
                  <h2 class="marker__content--title">${title}</h2>
                  <p class="marker__content--text address">${address}</p>
                    <table>
                        <tr>
                            <td>${lang === "cs" ? czWeekdays : enWeekdays}</td>
                            <td>
                                <span>${weekdaysOpening}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>${lang === "cs" ? czSaturday : enSaturday}</td>
                            <td>
                                <span>${saturdayOpening}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>${lang === "cs" ? czSunday : enSunday}</td>
                            <td>
                                <span>${sundayOpening}</span>
                            </td>
                        </tr>
                    </table>
                <div
            `
                }

                locations.forEach((location) => {

                    const marker = new google.maps.Marker({
                        position: {
                            lat: location.lat,
                            lng: location.lng
                        },
                        map,
                        animation: google.maps.Animation.DROP
                    });

                    const infowindow = new google.maps.InfoWindow({
                        content: markerContent(location.name, location.address, location.weekdaysOpening, location.saturdayOpening, location.sundayOpening),
                    });

                    marker.addListener("click", () => {
                        infowindow.open({
                            anchor: marker,
                            map,
                            shouldFocus: false
                        });
                    });
                })
            }
        }
    }
};